const SECT_EVENT_DETAILS = 'event-details';

const SUPPORTING_DOCS = [
    {
        expect: [
            {
                baseField: `${SECT_EVENT_DETAILS}-event-type`,
                value: 'Dance'
            },
            {
                baseField: `${SECT_EVENT_DETAILS}-event-sub-type`,
                value: 'Modern & Contemporary'
            }
        ],
        title: 'Unscripted Performances e.g. Dance, Performance Art, Stand-up Comedy, Forum Theatre',
        list: [
            'Synopsis',
            'Completed [link]checklist for Unscripted and Multidisciplinary Performances in which relevant information about the works should be provided (e.g. performance score, stage direction, talking points, etc.)',
            'Rehearsal video or video of past performances where available',
            'Multimedia material. The picture and sound should be clear and of good quality. Video footage in a foreign language is to be accompanied by subtitles.'
        ],
        links: [
            {
                id: 'checklist',
                title: 'Content Checklist form',
                href: 'https://www.imda.gov.sg/-/media/Imda/Files/Regulation-Licensing-and-Consultations/Licensing/licenses/Content-Checklist-form-for-Unscripted-and-Multidisciplinary-Performances.pdf'
            }
        ]
    },
    {
        expect: [
            {
                baseField: `${SECT_EVENT_DETAILS}-event-type`,
                value: 'Dance'
            },
            {
                baseField: `${SECT_EVENT_DETAILS}-event-sub-type`,
                value: 'Modern and Contemporary'
            }
        ],
        title: 'Unscripted Performances e.g. Dance, Performance Art, Stand-up Comedy, Forum Theatre',
        list: [
            'Synopsis',
            'Completed [link]checklist for Unscripted and Multidisciplinary Performances in which relevant information about the works should be provided (e.g. performance score, stage direction, talking points, etc.)',
            'Rehearsal video or video of past performances where available',
            'Multimedia material. The picture and sound should be clear and of good quality. Video footage in a foreign language is to be accompanied by subtitles.'
        ],
        links: [
            {
                id: 'checklist',
                title: 'Content Checklist form',
                href: 'https://www.imda.gov.sg/-/media/Imda/Files/Regulation-Licensing-and-Consultations/Licensing/licenses/Content-Checklist-form-for-Unscripted-and-Multidisciplinary-Performances.pdf'
            }
        ]
    },
    {
        expect: [
            {
                baseField: `${SECT_EVENT_DETAILS}-event-type`,
                value: 'Dance'
            },
            {
                baseField: `${SECT_EVENT_DETAILS}-event-sub-type`,
                value: 'Others'
            }
        ],
        title: 'Unscripted Performances e.g. Dance, Performance Art, Stand-up Comedy, Forum Theatre',
        list: [
            'Synopsis',
            'Completed [link]checklist for Unscripted and Multidisciplinary Performances in which relevant information about the works should be provided (e.g. performance score, stage direction, talking points, etc.)',
            'Rehearsal video or video of past performances where available',
            'Multimedia material. The picture and sound should be clear and of good quality. Video footage in a foreign language is to be accompanied by subtitles.'
        ],
        links: [
            {
                id: 'checklist',
                title: 'Content Checklist form',
                href: 'https://www.imda.gov.sg/-/media/Imda/Files/Regulation-Licensing-and-Consultations/Licensing/licenses/Content-Checklist-form-for-Unscripted-and-Multidisciplinary-Performances.pdf'
            }
        ]
    },
    {
        expect: [
            {
                baseField: `${SECT_EVENT_DETAILS}-event-type`,
                value: 'Dance'
            },
            {
                baseField: `${SECT_EVENT_DETAILS}-event-sub-type`,
                value: 'Others'
            }
        ],
        title: 'Multi-disciplinary Arts Entertainment',
        list: [
            'Synopsis',
            'Completed [link]checklist for Unscripted and Multidisciplinary Performances',
            'Detailed programme schedule, including the title and duration of each performance and name(s) of artist(s)',
            'Finalised script',
            'Set list and lyrics for all songs. For lyrics in a foreign language, English translations are to be provided.',
            'Layout plan of the event location',
            'Photographs/ Images of exhibits',
            'Rehearsal video or video of past performances where available',
            'Multimedia material. The picture and sound should be clear and of good quality. Video footage in a foreign language is to be accompanied by subtitles.'
        ],
        links: [
            {
                id: 'checklist',
                title: 'Content Checklist form',
                href: 'https://www.imda.gov.sg/-/media/Imda/Files/Regulation-Licensing-and-Consultations/Licensing/licenses/Content-Checklist-form-for-Unscripted-and-Multidisciplinary-Performances.pdf'
            }
        ]
    },
    {
        expect: [
            {
                baseField: `${SECT_EVENT_DETAILS}-event-type`,
                value: 'Exhibition'
            },
            {
                baseField: `${SECT_EVENT_DETAILS}-event-sub-type`,
                value: 'Photography'
            }
        ],
        title: 'Art Exhibitions',
        list: [
            'Synopsis/ Theme of exhibition',
            'Wall texts',
            'Photographs/ Images of each exhibit',
            'Multimedia material. The picture and sound should be clear and of good quality. Video footage in a foreign language is to be accompanied by subtitles.',
            'For exhibitions featuring archival materials including audio visual, text, image, photograph, etc., the materials should be clear and of good quality.'
        ]
    },
    {
        expect: [
            {
                baseField: `${SECT_EVENT_DETAILS}-event-type`,
                value: 'Exhibition'
            },
            {
                baseField: `${SECT_EVENT_DETAILS}-event-sub-type`,
                value: 'Installation Art'
            }
        ],
        title: 'Art Exhibitions',
        list: [
            'Synopsis/ Theme of exhibition',
            'Wall texts',
            'Photographs/ Images of each exhibit',
            'Multimedia material. The picture and sound should be clear and of good quality. Video footage in a foreign language is to be accompanied by subtitles.',
            'For exhibitions featuring archival materials including audio visual, text, image, photograph, etc., the materials should be clear and of good quality.'
        ]
    },
    {
        expect: [
            {
                baseField: `${SECT_EVENT_DETAILS}-event-type`,
                value: 'Exhibition'
            },
            {
                baseField: `${SECT_EVENT_DETAILS}-event-sub-type`,
                value: 'Multidisciplinary'
            }
        ],
        title: 'Art Exhibitions',
        list: [
            'Synopsis/ Theme of exhibition',
            'Wall texts',
            'Photographs/ Images of each exhibit',
            'Multimedia material. The picture and sound should be clear and of good quality. Video footage in a foreign language is to be accompanied by subtitles.',
            'For exhibitions featuring archival materials including audio visual, text, image, photograph, etc., the materials should be clear and of good quality.'
        ]
    },
    {
        expect: [
            {
                baseField: `${SECT_EVENT_DETAILS}-event-type`,
                value: 'Exhibition'
            },
            {
                baseField: `${SECT_EVENT_DETAILS}-event-sub-type`,
                value: 'Others'
            }
        ],
        title: 'Art Exhibitions',
        list: [
            'Synopsis/ Theme of exhibition',
            'Wall texts',
            'Photographs/ Images of each exhibit',
            'Multimedia material. The picture and sound should be clear and of good quality. Video footage in a foreign language is to be accompanied by subtitles.',
            'For exhibitions featuring archival materials including audio visual, text, image, photograph, etc., the materials should be clear and of good quality.'
        ]
    },
    {
        expect: [
            {
                baseField: `${SECT_EVENT_DETAILS}-event-type`,
                value: 'Exhibition'
            },
            {
                baseField: `${SECT_EVENT_DETAILS}-event-sub-type`,
                value: 'Others'
            }
        ],
        title: 'Multi-disciplinary Arts Entertainment',
        list: [
            'Synopsis',
            'Completed [link]checklist for Unscripted and Multidisciplinary Performances',
            'Detailed programme schedule, including the title and duration of each performance and name(s) of artist(s)',
            'Finalised script',
            'Set list and lyrics for all songs. For lyrics in a foreign language, English translations are to be provided.',
            'Layout plan of the event location',
            'Photographs/ Images of exhibits',
            'Rehearsal video or video of past performances where available',
            'Multimedia material. The picture and sound should be clear and of good quality. Video footage in a foreign language is to be accompanied by subtitles.'
        ],
        links: [
            {
                id: 'checklist',
                title: 'Content Checklist form',
                href: 'https://www.imda.gov.sg/-/media/Imda/Files/Regulation-Licensing-and-Consultations/Licensing/licenses/Content-Checklist-form-for-Unscripted-and-Multidisciplinary-Performances.pdf'
            }
        ]
    },
    {
        expect: [
            {
                baseField: `${SECT_EVENT_DETAILS}-event-type`,
                value: 'Literary Reading'
            },
            {
                baseField: `${SECT_EVENT_DETAILS}-event-sub-type`,
                value: 'Play Reading'
            }
        ],
        title: 'Plays, Play-Reading and Poetry Recital',
        list: [
            'Synopsis',
            'Finalised script. For scripts in a foreign language, English translations are to be provided.',
            'Multimedia material. The picture and sound should be clear and of good quality. Video footage in a foreign language is to be accompanied by subtitles.'
        ]
    },
    {
        expect: [
            {
                baseField: `${SECT_EVENT_DETAILS}-event-type`,
                value: 'Literary Reading'
            },
            {
                baseField: `${SECT_EVENT_DETAILS}-event-sub-type`,
                value: 'Poetry Reading'
            }
        ],
        title: 'Plays, Play-Reading and Poetry Recital',
        list: [
            'Synopsis',
            'Finalised script. For scripts in a foreign language, English translations are to be provided.',
            'Multimedia material. The picture and sound should be clear and of good quality. Video footage in a foreign language is to be accompanied by subtitles.'
        ]
    },
    {
        expect: [
            {
                baseField: `${SECT_EVENT_DETAILS}-event-type`,
                value: 'Literary Reading'
            },
            {
                baseField: `${SECT_EVENT_DETAILS}-event-sub-type`,
                value: 'Others'
            }
        ],
        title: 'Plays, Play-Reading and Poetry Recital',
        list: [
            'Synopsis',
            'Finalised script. For scripts in a foreign language, English translations are to be provided.',
            'Multimedia material. The picture and sound should be clear and of good quality. Video footage in a foreign language is to be accompanied by subtitles.'
        ]
    },
    {
        expect: [
            {
                baseField: `${SECT_EVENT_DETAILS}-event-type`,
                value: 'Literary Reading'
            },
            {
                baseField: `${SECT_EVENT_DETAILS}-event-sub-type`,
                value: 'Others'
            }
        ],
        title: 'Multi-disciplinary Arts Entertainment',
        list: [
            'Synopsis',
            'Completed [link]checklist for Unscripted and Multidisciplinary Performances',
            'Detailed programme schedule, including the title and duration of each performance and name(s) of artist(s)',
            'Finalised script',
            'Set list and lyrics for all songs. For lyrics in a foreign language, English translations are to be provided.',
            'Layout plan of the event location',
            'Photographs/ Images of exhibits',
            'Rehearsal video or video of past performances where available',
            'Multimedia material. The picture and sound should be clear and of good quality. Video footage in a foreign language is to be accompanied by subtitles.'
        ],
        links: [
            {
                id: 'checklist',
                title: 'Content Checklist form',
                href: 'https://www.imda.gov.sg/-/media/Imda/Files/Regulation-Licensing-and-Consultations/Licensing/licenses/Content-Checklist-form-for-Unscripted-and-Multidisciplinary-Performances.pdf'
            }
        ]
    },
    {
        expect: [
            {
                baseField: `${SECT_EVENT_DETAILS}-event-type`,
                value: 'Play'
            },
            {
                baseField: `${SECT_EVENT_DETAILS}-event-sub-type`,
                value: 'Drama'
            }
        ],
        title: 'Plays, Play-Reading and Poetry Recital',
        list: [
            'Synopsis',
            'Finalised script. For scripts in a foreign language, English translations are to be provided.',
            'Multimedia material. The picture and sound should be clear and of good quality. Video footage in a foreign language is to be accompanied by subtitles.'
        ]
    },
    {
        expect: [
            {
                baseField: `${SECT_EVENT_DETAILS}-event-type`,
                value: 'Play'
            },
            {
                baseField: `${SECT_EVENT_DETAILS}-event-sub-type`,
                value: 'Musical'
            }
        ],
        title: 'Plays, Play-Reading and Poetry Recital',
        list: [
            'Synopsis',
            'Finalised script. For scripts in a foreign language, English translations are to be provided.',
            'Multimedia material. The picture and sound should be clear and of good quality. Video footage in a foreign language is to be accompanied by subtitles.'
        ]
    },
    {
        expect: [
            {
                baseField: `${SECT_EVENT_DETAILS}-event-type`,
                value: 'Play'
            },
            {
                baseField: `${SECT_EVENT_DETAILS}-event-sub-type`,
                value: 'Forum & Interactive'
            }
        ],
        title: 'Plays, Play-Reading and Poetry Recital',
        list: [
            'Synopsis',
            'Finalised script. For scripts in a foreign language, English translations are to be provided.',
            'Multimedia material. The picture and sound should be clear and of good quality. Video footage in a foreign language is to be accompanied by subtitles.'
        ]
    },
    {
        expect: [
            {
                baseField: `${SECT_EVENT_DETAILS}-event-type`,
                value: 'Play'
            },
            {
                baseField: `${SECT_EVENT_DETAILS}-event-sub-type`,
                value: 'Forum & Interactive'
            }
        ],
        title: 'Unscripted Performances e.g. Dance, Performance Art, Stand-up Comedy, Forum Theatre',
        list: [
            'Synopsis',
            'Completed [link]checklist for Unscripted and Multidisciplinary Performances in which relevant information about the works should be provided (e.g. performance score, stage direction, talking points, etc.)',
            'Rehearsal video or video of past performances where available',
            'Multimedia material. The picture and sound should be clear and of good quality. Video footage in a foreign language is to be accompanied by subtitles.'
        ],
        links: [
            {
                id: 'checklist',
                title: 'Content Checklist form',
                href: 'https://www.imda.gov.sg/-/media/Imda/Files/Regulation-Licensing-and-Consultations/Licensing/licenses/Content-Checklist-form-for-Unscripted-and-Multidisciplinary-Performances.pdf'
            }
        ]
    },
    {
        expect: [
            {
                baseField: `${SECT_EVENT_DETAILS}-event-type`,
                value: 'Play'
            },
            {
                baseField: `${SECT_EVENT_DETAILS}-event-sub-type`,
                value: 'Performance Art'
            }
        ],
        title: 'Unscripted Performances e.g. Dance, Performance Art, Stand-up Comedy, Forum Theatre',
        list: [
            'Synopsis',
            'Completed [link]checklist for Unscripted and Multidisciplinary Performances in which relevant information about the works should be provided (e.g. performance score, stage direction, talking points, etc.)',
            'Rehearsal video or video of past performances where available',
            'Multimedia material. The picture and sound should be clear and of good quality. Video footage in a foreign language is to be accompanied by subtitles.'
        ],
        links: [
            {
                id: 'checklist',
                title: 'Content Checklist form',
                href: 'https://www.imda.gov.sg/-/media/Imda/Files/Regulation-Licensing-and-Consultations/Licensing/licenses/Content-Checklist-form-for-Unscripted-and-Multidisciplinary-Performances.pdf'
            }
        ]
    },
    {
        expect: [
            {
                baseField: `${SECT_EVENT_DETAILS}-event-type`,
                value: 'Play'
            },
            {
                baseField: `${SECT_EVENT_DETAILS}-event-sub-type`,
                value: 'Comedy Show'
            }
        ],
        title: 'Plays, Play-Reading and Poetry Recital',
        list: [
            'Synopsis',
            'Finalised script. For scripts in a foreign language, English translations are to be provided.',
            'Multimedia material. The picture and sound should be clear and of good quality. Video footage in a foreign language is to be accompanied by subtitles.'
        ]
    },
    {
        expect: [
            {
                baseField: `${SECT_EVENT_DETAILS}-event-type`,
                value: 'Play'
            },
            {
                baseField: `${SECT_EVENT_DETAILS}-event-sub-type`,
                value: 'Comedy Show'
            }
        ],
        title: 'Unscripted Performances e.g. Dance, Performance Art, Stand-up Comedy, Forum Theatre',
        list: [
            'Synopsis',
            'Completed [link]checklist for Unscripted and Multidisciplinary Performances in which relevant information about the works should be provided (e.g. performance score, stage direction, talking points, etc.)',
            'Rehearsal video or video of past performances where available',
            'Multimedia material. The picture and sound should be clear and of good quality. Video footage in a foreign language is to be accompanied by subtitles.'
        ],
        links: [
            {
                id: 'checklist',
                title: 'Content Checklist form',
                href: 'https://www.imda.gov.sg/-/media/Imda/Files/Regulation-Licensing-and-Consultations/Licensing/licenses/Content-Checklist-form-for-Unscripted-and-Multidisciplinary-Performances.pdf'
            }
        ]
    },
    {
        expect: [
            {
                baseField: `${SECT_EVENT_DETAILS}-event-type`,
                value: 'Play'
            },
            {
                baseField: `${SECT_EVENT_DETAILS}-event-sub-type`,
                value: 'Improvisation'
            }
        ],
        title: 'Improv Performances',
        list: [
            'Synopsis',
            'Completed [link]checklist for Improv Performances',
            'Detailed programme schedule, including the title and duration of each performance and name(s) of artist(s)',
            'Rehearsal video or video of past performances where available',
            'Multimedia material. The picture and sound should be clear and of good quality. Video footage in a foreign language is to be accompanied by subtitles.'
        ],
        links: [
            {
                id: 'checklist',
                title: 'Content Checklist form',
                href: 'https://www.imda.gov.sg/-/media/Imda/Files/Regulation-Licensing-and-Consultations/Licensing/licenses/Content-Checklist-for-Improv-Performances.pdf'
            }
        ]
    },
    {
        expect: [
            {
                baseField: `${SECT_EVENT_DETAILS}-event-type`,
                value: 'Play'
            },
            {
                baseField: `${SECT_EVENT_DETAILS}-event-sub-type`,
                value: 'Others'
            }
        ],
        title: 'Plays, Play-Reading and Poetry Recital',
        list: [
            'Synopsis',
            'Finalised script. For scripts in a foreign language, English translations are to be provided.',
            'Multimedia material. The picture and sound should be clear and of good quality. Video footage in a foreign language is to be accompanied by subtitles.'
        ]
    },
    {
        expect: [
            {
                baseField: `${SECT_EVENT_DETAILS}-event-type`,
                value: 'Play'
            },
            {
                baseField: `${SECT_EVENT_DETAILS}-event-sub-type`,
                value: 'Others'
            }
        ],
        title: 'Multi-disciplinary Arts Entertainment',
        list: [
            'Synopsis',
            'Completed [link]checklist for Unscripted and Multidisciplinary Performances',
            'Detailed programme schedule, including the title and duration of each performance and name(s) of artist(s)',
            'Finalised script',
            'Set list and lyrics for all songs. For lyrics in a foreign language, English translations are to be provided.',
            'Layout plan of the event location',
            'Photographs/ Images of exhibits',
            'Rehearsal video or video of past performances where available',
            'Multimedia material. The picture and sound should be clear and of good quality. Video footage in a foreign language is to be accompanied by subtitles.'
        ],
        links: [
            {
                id: 'checklist',
                title: 'Content Checklist form',
                href: 'https://www.imda.gov.sg/-/media/Imda/Files/Regulation-Licensing-and-Consultations/Licensing/licenses/Content-Checklist-form-for-Unscripted-and-Multidisciplinary-Performances.pdf'
            }
        ]
    },
    {
        expect: [
            {
                baseField: `${SECT_EVENT_DETAILS}-event-type`,
                value: 'Music Performance / Concert'
            },
            {
                baseField: `${SECT_EVENT_DETAILS}-event-sub-type`,
                value: 'Variety Show'
            }
        ],
        title: 'Pop/Rock Concerts and Variety Shows',
        list: [
            'Detailed programme schedule',
            'Layout plan of the event location',
            'Set list and lyrics for all songs. For lyrics in a foreign language, English translations are to be provided.',
            'Name(s) of artiste(s), including guest performers',
            'Multimedia material. The picture and sound should be clear and of good quality. Video footage in a foreign language is to be accompanied by subtitles.'
        ]
    },
    {
        expect: [
            {
                baseField: `${SECT_EVENT_DETAILS}-event-type`,
                value: 'Music Performance / Concert'
            },
            {
                baseField: `${SECT_EVENT_DETAILS}-event-sub-type`,
                value: 'Metal'
            }
        ],
        title: 'Pop/Rock Concerts and Variety Shows',
        list: [
            'Detailed programme schedule',
            'Layout plan of the event location',
            'Set list and lyrics for all songs. For lyrics in a foreign language, English translations are to be provided.',
            'Name(s) of artiste(s), including guest performers',
            'Multimedia material. The picture and sound should be clear and of good quality. Video footage in a foreign language is to be accompanied by subtitles.'
        ]
    },
    {
        expect: [
            {
                baseField: `${SECT_EVENT_DETAILS}-event-type`,
                value: 'Music Performance / Concert'
            },
            {
                baseField: `${SECT_EVENT_DETAILS}-event-sub-type`,
                value: 'Pop'
            }
        ],
        title: 'Pop/Rock Concerts and Variety Shows',
        list: [
            'Detailed programme schedule',
            'Layout plan of the event location',
            'Set list and lyrics for all songs. For lyrics in a foreign language, English translations are to be provided.',
            'Name(s) of artiste(s), including guest performers',
            'Multimedia material. The picture and sound should be clear and of good quality. Video footage in a foreign language is to be accompanied by subtitles.'
        ]
    },
    {
        expect: [
            {
                baseField: `${SECT_EVENT_DETAILS}-event-type`,
                value: 'Music Performance / Concert'
            },
            {
                baseField: `${SECT_EVENT_DETAILS}-event-sub-type`,
                value: 'Rock'
            }
        ],
        title: 'Pop/Rock Concerts and Variety Shows',
        list: [
            'Detailed programme schedule',
            'Layout plan of the event location',
            'Set list and lyrics for all songs. For lyrics in a foreign language, English translations are to be provided.',
            'Name(s) of artiste(s), including guest performers',
            'Multimedia material. The picture and sound should be clear and of good quality. Video footage in a foreign language is to be accompanied by subtitles.'
        ]
    },
    {
        expect: [
            {
                baseField: `${SECT_EVENT_DETAILS}-event-type`,
                value: 'Music Performance / Concert'
            },
            {
                baseField: `${SECT_EVENT_DETAILS}-event-sub-type`,
                value: 'Hip Hop / Rap'
            }
        ],
        title: 'Pop/Rock Concerts and Variety Shows',
        list: [
            'Detailed programme schedule',
            'Layout plan of the event location',
            'Set list and lyrics for all songs. For lyrics in a foreign language, English translations are to be provided.',
            'Name(s) of artiste(s), including guest performers',
            'Multimedia material. The picture and sound should be clear and of good quality. Video footage in a foreign language is to be accompanied by subtitles.'
        ]
    },
    {
        expect: [
            {
                baseField: `${SECT_EVENT_DETAILS}-event-type`,
                value: 'Music Performance / Concert'
            },
            {
                baseField: `${SECT_EVENT_DETAILS}-event-sub-type`,
                value: 'Others'
            }
        ],
        title: 'Pop/Rock Concerts and Variety Shows',
        list: [
            'Detailed programme schedule',
            'Layout plan of the event location',
            'Set list and lyrics for all songs. For lyrics in a foreign language, English translations are to be provided.',
            'Name(s) of artiste(s), including guest performers',
            'Multimedia material. The picture and sound should be clear and of good quality. Video footage in a foreign language is to be accompanied by subtitles.'
        ]
    },
    {
        expect: [
            {
                baseField: `${SECT_EVENT_DETAILS}-event-type`,
                value: 'Music Performance / Concert'
            },
            {
                baseField: `${SECT_EVENT_DETAILS}-event-sub-type`,
                value: 'Others'
            }
        ],
        title: 'Multi-disciplinary Arts Entertainment',
        list: [
            'Synopsis',
            'Completed [link]checklist for Unscripted and Multidisciplinary Performances',
            'Detailed programme schedule, including the title and duration of each performance and name(s) of artist(s)',
            'Finalised script',
            'Set list and lyrics for all songs. For lyrics in a foreign language, English translations are to be provided.',
            'Layout plan of the event location',
            'Photographs/ Images of exhibits',
            'Rehearsal video or video of past performances where available',
            'Multimedia material. The picture and sound should be clear and of good quality. Video footage in a foreign language is to be accompanied by subtitles.'
        ],
        links: [
            {
                id: 'checklist',
                title: 'Content Checklist form',
                href: 'https://www.imda.gov.sg/-/media/Imda/Files/Regulation-Licensing-and-Consultations/Licensing/licenses/Content-Checklist-form-for-Unscripted-and-Multidisciplinary-Performances.pdf'
            }
        ]
    },
    {
        expect: [
            {
                baseField: `${SECT_EVENT_DETAILS}-event-type`,
                value: 'Others'
            },
            {
                baseField: `${SECT_EVENT_DETAILS}-event-sub-type`,
                value: 'Others'
            }
        ],
        title: 'Multi-disciplinary Arts Entertainment',
        list: [
            'Synopsis',
            'Completed [link]checklist for Unscripted and Multidisciplinary Performances',
            'Detailed programme schedule, including the title and duration of each performance and name(s) of artist(s)',
            'Finalised script',
            'Set list and lyrics for all songs. For lyrics in a foreign language, English translations are to be provided.',
            'Layout plan of the event location',
            'Photographs/ Images of exhibits',
            'Rehearsal video or video of past performances where available',
            'Multimedia material. The picture and sound should be clear and of good quality. Video footage in a foreign language is to be accompanied by subtitles.'
        ],
        links: [
            {
                id: 'checklist',
                title: 'Content Checklist form',
                href: 'https://www.imda.gov.sg/-/media/Imda/Files/Regulation-Licensing-and-Consultations/Licensing/licenses/Content-Checklist-form-for-Unscripted-and-Multidisciplinary-Performances.pdf'
            }
        ]
    }
];

export default SUPPORTING_DOCS;
